import React, { FC, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useFetchLayers } from 'services/layer'
import { Map } from './components/Map'
import { Panel } from './components/Panel'
import styles from './Project.module.scss'
import { Flex } from 'components/Flex'
import { useUpdateProject, useFetchProject, useFetchArea } from 'services/project'
import { useUserContext } from 'context/user-context'
import { debounce } from 'utils/debounce'
import { ProjectProvider, useProjectContext } from 'context/project-context'
import { MapEditorProvider } from 'context/map-editor-context'
import { Loading } from 'components/Loading'
import { useUpdateUser } from 'services/user'

export const Project: FC = () => {
  const { layers = [] } = useFetchLayers()
  const { projectId, areaId } = useParams()
  const { project } = useFetchProject(projectId)
  const { area } = useFetchArea(projectId, areaId)
  const mapKey = ['map', projectId, areaId].join('-')
  const projectLoaded = !projectId || (projectId && project)
  const [currentUser] = useUserContext()
  const [updateUser] = useUpdateUser(currentUser!.id)

  if (!projectLoaded) return <Loading />

  var guia = false;
  var flagguia = 1;
  var chbguia = false;

  if (currentUser?.guide === false) {
    guia = false;
  } else {
    guia = true;
  }

  function handleInputChange() {
    if (chbguia === false) {
      chbguia = true;
    } else {
      chbguia = false;
    }
  }

  function cerrarGuia() {
    document.getElementById('fondoguia')!.style.display = "none";
    document.getElementById('box')!.style.display = "none";

    if (chbguia === true) {
      updateUser(
        { guide: false },
        {
          onError: () => console.log("error"),
          onSuccess: () => console.log("éxito"),
        },
      )
    }
  }


  function continuarGuia() {
    if (flagguia === 1) {
      /*var x = document.getElementsByClassName("Icon_icon__1Yr2D ri-map-pin-line ri-1x");
      var coords = x[0].getBoundingClientRect();
      document.getElementById('box1')!.style.top = String(coords.top) + "px";
      document.getElementById('box1')!.style.left = String(coords.left + 150) + "px";*/

      document.getElementById('box1')!.style.display = "block";
      document.getElementById('box')!.style.display = "none";
      document.getElementById('img1')!.style.display = "block";

    }
    if (flagguia === 2) {
      /*var x = document.getElementsByClassName("Panel_panelContent__Or6k2");
      var coords = x[0].getBoundingClientRect();
      document.getElementById('box2')!.style.top = String(coords.top) + "px";
      document.getElementById('box2')!.style.left = String(coords.left - 150) + "px";*/

      document.getElementById('img1')!.style.display = "none";
      document.getElementById('box2')!.style.display = "block";
      document.getElementById('box1')!.style.display = "none";

      var panel = document.getElementsByClassName("Panel_panel__1HfLI");
      var secapas = panel[0].getElementsByTagName("section");
      secapas[0].style.zIndex = "151";
      secapas[0].style.backgroundColor = "white";
      var btndespl = panel[0].getElementsByTagName("button");
      btndespl[0].style.zIndex = "1";
    }
    if (flagguia === 3) {
      /*var x = document.getElementsByClassName("Panel_panelContent__Or6k2");
      var coords = x[0].getBoundingClientRect();
      document.getElementById('box2')!.style.top = String(coords.top) + "px";
      document.getElementById('box2')!.style.left = String(coords.left - 150) + "px";*/

      var panel2 = document.getElementsByClassName("Panel_panel__1HfLI");
      var secapas2 = panel2[0].getElementsByTagName("section");
      secapas2[0].style.zIndex = "0";

      var panelviews = document.getElementsByClassName("Flex_flex__1LhAP Flex_justify-between__1Kt13 Flex_align-center__zk8s3 Flex_horizontal__wPUKF Panel_panelHeader__2ciTR");
      var views = panelviews[0].getElementsByTagName("div");
      views[0].style.zIndex = "151";
      views[0].style.backgroundColor = "white";

      document.getElementById('box3')!.style.display = "block";
      document.getElementById('box2')!.style.display = "none";
    }
    if (flagguia === 4) {
      var panelviews2 = document.getElementsByClassName("Flex_flex__1LhAP Flex_justify-between__1Kt13 Flex_align-center__zk8s3 Flex_horizontal__wPUKF Panel_panelHeader__2ciTR");
      var views2 = panelviews2[0].getElementsByTagName("div");
      views2[0].style.zIndex = "0";

      document.getElementById('img4')!.style.display = "block";
      document.getElementById('box4')!.style.display = "block";
      document.getElementById('box3')!.style.display = "none";
    }
    if (flagguia === 5) {
      document.getElementById('img5')!.style.display = "block";
      document.getElementById('img4')!.style.display = "none";
      document.getElementById('box5')!.style.display = "block";
      document.getElementById('box4')!.style.display = "none";
    }

    flagguia += 1;
  }

  function anteriorGuia() {
    flagguia -= 1;
    if (flagguia === 2) {
      document.getElementById('box2')!.style.display = "none";
      document.getElementById('box1')!.style.display = "block";
      document.getElementById('img1')!.style.display = "block";
      var panel3 = document.getElementsByClassName("Panel_panel__1HfLI");
      var secapas3 = panel3[0].getElementsByTagName("section");
      secapas3[0].style.zIndex = "0";
    }
    if (flagguia === 3) {
      document.getElementById('box3')!.style.display = "none";
      document.getElementById('box2')!.style.display = "block";
      var panel4 = document.getElementsByClassName("Panel_panel__1HfLI");
      var secapas4 = panel4[0].getElementsByTagName("section");
      secapas4[0].style.zIndex = "151";
      secapas4[0].style.backgroundColor = "white";

      var panelviews3 = document.getElementsByClassName("Flex_flex__1LhAP Flex_justify-between__1Kt13 Flex_align-center__zk8s3 Flex_horizontal__wPUKF Panel_panelHeader__2ciTR");
      var views3 = panelviews3[0].getElementsByTagName("div");
      views3[0].style.zIndex = "0";
    }
    if (flagguia === 4) {

      var panelviews4 = document.getElementsByClassName("Flex_flex__1LhAP Flex_justify-between__1Kt13 Flex_align-center__zk8s3 Flex_horizontal__wPUKF Panel_panelHeader__2ciTR");
      var views4 = panelviews4[0].getElementsByTagName("div");
      views4[0].style.zIndex = "151";

      document.getElementById('img4')!.style.display = "none";
      document.getElementById('box4')!.style.display = "none";
      document.getElementById('box3')!.style.display = "block";

    }
    if (flagguia === 5) {
      document.getElementById('img5')!.style.display = "none";
      document.getElementById('img4')!.style.display = "block";

      document.getElementById('box5')!.style.display = "none";
      document.getElementById('box4')!.style.display = "block";
    }
  }
  //var x = document.getElementsByClassName("Icon_icon__1Yr2D ri-traffic-light-line ri-1x");


  if (project?.reporttype !== undefined && window.location.href.includes("projects")) {
    localStorage.setItem("projectRT", String(project?.reporttype));
  } else {
    if (window.location.href.includes("explore")) {
      localStorage.setItem("projectRT", "1");
    }
  }







  return (
    <ProjectProvider key={projectId}>
      {
        guia === true && <div id="fondoguia" className={styles.popup}>
          <div id="box" className={styles.pwindowfi}>

            <div style={{ width: '100%', textAlign: 'center', fontSize: '25px', fontWeight: 'bolder' }}>
              ¿TU PRIMER VIAJE POR DESCIFRA?
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'justify' }}>
              En <span style={{ fontWeight: 'bolder' }}>5 sencillos pasos</span> descubre lo que puedes hacer con las funcionalidades base de DESCIFRA para tus proyectos.
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <button className={styles.btnRosa} onClick={continuarGuia}>INICIAR MI VIAJE</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <button onClick={cerrarGuia} className={styles.btnRosa}>POR AHORA NO</button>
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              Obtén la experiencia completa y agenda con nuestros expertos <a target="_blank" rel="noopener noreferrer" style={{ color: 'rgb(3,32,79)' }} href="https://app.hubspot.com/meetings/viridiana3">¡Ahora!</a>
            </div><br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <input id="nvmg" type="checkbox" className={styles.chbx} onClick={handleInputChange} />No volver a preguntar
            </div>
          </div>

          <div id="img1" className={styles.img1} style={{ display: 'none' }}>
            <img style={{ width: '67%' }} alt="img" src="https://report.descifra.global/ImagenesCarto/menutools_na.png"></img>
          </div>


          <div id="box1" className={styles.pwindow} style={{ display: 'none', top: '20%', left: '20%' }}>

            <div style={{ width: '100%', textAlign: 'left', fontSize: '25px', fontWeight: 'bolder' }}>
              1. CREA TU ZONA DE ANÁLISIS
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'justify' }}>
              En esta sección encontrarás las herramientas para crear tus proyectos a partir de una ubicación.
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <button className={styles.btnRosa} onClick={continuarGuia}>SIGUIENTE</button>
            </div> <br></br>
          </div>


          <div id="box2" className={styles.pwindow} style={{ display: 'none', top: '30%', left: '60%' }}>

            <div style={{ width: '100%', textAlign: 'left', fontSize: '25px', fontWeight: 'bolder' }}>
              2. VISUALIZA INFORMACIÓN EN EL MAPA
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'justify' }}>
              Aquí selecciona las capas de información que requieras para conocer más del entorno y su población en tu zona de análisis.
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <button className={styles.btnRosa} onClick={anteriorGuia}>ANTERIOR</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <button onClick={continuarGuia} className={styles.btnRosa}>SIGUIENTE</button>
            </div> <br></br>
          </div>

          <div id="box3" className={styles.pwindow} style={{ display: 'none', top: '20%', left: '72%' }}>

            <div style={{ width: '100%', textAlign: 'left', fontSize: '25px', fontWeight: 'bolder' }}>
              3. EVALUA Y FILTRA LA INFORMACIÓN
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'justify' }}>
              Apóyate de gráficos dinámicos en este panel para filtrar la información de las capas seleccionadas.
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <button className={styles.btnRosa} onClick={anteriorGuia}>ANTERIOR</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <button onClick={continuarGuia} className={styles.btnRosa}>SIGUIENTE</button>
            </div> <br></br>
          </div>

          <div id="img4" className={styles.img4} style={{ display: 'none' }}>
            <img style={{ width: '68%' }} alt="img" src="https://report.descifra.global/ImagenesCarto/trafico_n.png"></img>
          </div>

          <div id="box4" className={styles.pwindow} style={{ display: 'none', top: '30%', left: '20%' }}>

            <div style={{ width: '100%', textAlign: 'left', fontSize: '25px', fontWeight: 'bolder' }}>
              4. REALIZA UN ANÁLISIS DEL TRÁFICO VEHICULAR
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'justify' }}>
              Con este Add-On conocerás la capacidad y la tasa de demanda vehicular, la velocidad promedio y la hora pico en una ubicación.
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <button className={styles.btnRosa} onClick={anteriorGuia}>ANTERIOR</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <button onClick={continuarGuia} className={styles.btnRosa}>SIGUIENTE</button>
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              Descubre otros Add-Ons disponibles para tu negocio <a target="_blank" rel="noopener noreferrer" style={{ color: 'rgb(3,32,79)' }} href="https://app.hubspot.com/meetings/viridiana3">AQUÍ</a>
            </div><br></br>
          </div>

          <div id="img5" className={styles.img5} style={{ display: 'none' }}>
            <img style={{ width: '65%' }} alt="img" src="https://report.descifra.global/ImagenesCarto/reportes_n.png"></img>
          </div>

          <div id="box5" className={styles.pwindowfi} style={{ display: 'none', top: '57%', left: '25%' }}>

            <div style={{ width: '100%', textAlign: 'left', fontSize: '25px', fontWeight: 'bolder' }}>
              5. GENERA REPORTES PREDICTIVOS Y DE MOVILIDAD
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'justify' }}>
              Con estas funciones obtendrás reportes acerca de la afluencia por día y hora, así como información demográfica de la población. <br></br>
              Conoce todo acerca de nuestros reportes predictivos <a target="_blank" rel="noopener noreferrer" style={{ color: 'rgb(3,32,79)' }} href="https://app.hubspot.com/meetings/viridiana3">AQUÍ</a>
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <button className={styles.btnRosa} onClick={anteriorGuia}>ANTERIOR</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <button onClick={cerrarGuia} className={styles.btnRosa}>FINALIZAR MI VIAJE</button>
            </div> <br></br>
            <div style={{ width: '100%', textAlign: 'justify' }}>
              <span style={{ fontWeight: 'bolder' }}>NOTA:</span> Para obtener la experiencia completa de nuestros reportes personalizados y modelos predictivos avanzados agenda tu cita con nuestros expertos <a target="_blank" rel="noopener noreferrer" style={{ color: 'rgb(3,32,79)' }} href="https://app.hubspot.com/meetings/viridiana3">AQUÍ</a>
            </div><br></br>
          </div>
        </div>
      }

      <MapEditorProvider>
        {project && <SyncProject project={project} />}
        <Flex className={styles.project}>
          <Map layers={layers} key={mapKey} project={project} area={area} />
          <Panel layers={layers} project={project} area={area} />
        </Flex>
      </MapEditorProvider>
    </ProjectProvider>
  )
}

Project.displayName = 'Project'

const SyncProject: FC<any> = ({ project }) => {
  const [syncProject] = useUpdateProject(project?.id)
  const [{ activeLayers, hiddenLayers, filters }, projectDispatch] = useProjectContext()

  useEffect(() => projectDispatch.loadProject(project), [project.id]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (project) {
      debounce(syncProject, 500)({ activeLayers, hiddenLayers, filters })
    }
  }, [activeLayers, hiddenLayers, filters]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}
